import { render, staticRenderFns } from "./deanFormRow.vue?vue&type=template&id=2b3023a0&scoped=true"
import script from "./deanFormRow.vue?vue&type=script&lang=ts"
export * from "./deanFormRow.vue?vue&type=script&lang=ts"
import style0 from "./deanFormRow.vue?vue&type=style&index=0&id=2b3023a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3023a0",
  null
  
)

export default component.exports